const defaultData = [
  { name: 'Instagram Post', value: 'https://www.instagram.com/p/Ca9Q1VMgsVe/' },
  { name: 'Monobank card', value: '4242 4242 4242 4242' },
];

export default defaultData;
